<template>
  <h1 @click="open">Connect</h1>
  <h1 @click="write">Save</h1>
  <textarea v-model="state.code" />
  {{ state.fileHandle }}
</template>

<script>
import { defineComponent } from "vue";
import { state } from "@/state";
import { open, write } from "../fs.js";

export default defineComponent({
  name: "Test",
  setup() {
    return { state, open, write };
  }
});
</script>
